(function (Drupal, drupalSettings) {
  Drupal.behaviors.serviceLieuxTabs = {
    attach: function (context, settings) {
      const lieuxLists = context.querySelectorAll(
        ".direct-contact .lieux-list"
      );
      lieuxLists.forEach((lieuxList) => {
        if (!lieuxList.dataset.serviceLieuxTabsProcessed) {
          lieuxList.dataset.serviceLieuxTabsProcessed = "true";

          const firstLink = lieuxList.querySelector("li:first-child a");
          if (firstLink) {
            firstLink.classList.add("active");
            const firstId = firstLink.getAttribute("data-item");
            const firstService = context.querySelector(
              `.service[data-item="${firstId}"]`
            );
            if (firstService) {
              firstService.classList.add("active");
            }
          }

          const links = lieuxList.querySelectorAll("li a");
          links.forEach((link) => {
            link.addEventListener("click", function (e) {
              e.preventDefault();
              links.forEach((l) => l.classList.remove("active"));
              link.classList.add("active");

              const toLink = link.getAttribute("data-item");
              const services = context.querySelectorAll(
                ".direct-contact .service"
              );
              services.forEach((service) => service.classList.remove("active"));

              const targetService = context.querySelector(
                `.service[data-item="${toLink}"]`
              );
              if (targetService) {
                targetService.classList.add("active");
              }
            });
          });
        }
      });
    },
  };
})(Drupal, drupalSettings);
